// extracted by mini-css-extract-plugin
export default {"dark":"u7b_V0","light":"fihf_V"};